import {useMutation} from "@tanstack/react-query";
import {addCustomerOfferNoteMutationOptions} from "./add-customer-offer-note.mutation-options";

export function useAddCustomerOfferNote(id: string) {
  return useMutation(addCustomerOfferNoteMutationOptions(id));
}
